import { Badge } from '@music-vine/cadence/ui';
import { plans } from '@/fixtures/plans';
import { useRoles } from '@/hooks/auth';
import type { BadgeProps } from '@music-vine/cadence/ui';
const badgeVariants = {
  Free: 'bold',
  Essentials: 'brand',
  Creator: 'brand',
  Pro: 'brand',
  Business: 'brand'
} as const;
type BadgeVariantKey = keyof typeof badgeVariants;
export const UserBadge = ({
  size = 'sm'
}: {
  size?: BadgeProps['size'];
}) => {
  const roles = useRoles();
  const display = plans.find(plan => roles.has(plan.name))?.name ?? 'Free';
  const variantStyle: BadgeProps['variant'] = badgeVariants[display as BadgeVariantKey] ?? badgeVariants.Free;
  return <Badge className="text-nowrap rounded-full text-sm" data-testid="user-badge" size={size} variant={variantStyle} data-sentry-element="Badge" data-sentry-component="UserBadge" data-sentry-source-file="UserBadge.tsx">
      {display}
    </Badge>;
};